"use client";
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { FaChevronLeft, FaChevronRight, FaCirclePlay } from "react-icons/fa6";
import HomePageService from "@/services/api/HomeService";
import CommonImage from "@/components/common/image/CommonImage";
import "swiper/css";
import SkeletonStudentReviewSection from "@/components/common/skeletons/SkeletonStudentReviewSection";
import dynamic from "next/dynamic";
import VideoStoryModal from "@/components/common/Modal/VideoStoryModal";
import SwipperImage from "@/components/common/image/SwipperImage";
import { usePublicFetch } from "@/hook/usePublicFetch";
const Empty = dynamic(() => import("antd/es/empty"), { ssr: false });

export default function VediosStories({videoStories}) {
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentVideoLink, setcurrentVideoLink] = useState(null);



  const openModal = (video) => {
    setcurrentVideoLink(video.link);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setcurrentVideoLink(null);
  };

  return (
    <>
  
        <section className="video_story-section section_padding">
          <div className="container">
            <div className="section_title-center section_title-white">
              <h2 className="title">
                <span className="w-8 h-8">
                  <CommonImage
                    src="/images/admission-icon/video-icon.png"
                    className="img-icon"
                    alt="Book Icon"
                  />
                </span>
                আমাদের কণ্ঠে ফোকাস
              </h2>
              <p className="short-des">
                ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
                গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের
                মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
              </p>
            </div>

            <div className="section-content-wrap">
              {videoStories?.length > 0 ? (
                <div className="video-stories-slider">
                  <div className="student-review">
                    <Swiper
                      modules={[Navigation, Autoplay]}
                      slidesPerView={2}
                      spaceBetween={20}
                      autoplay={true}
                      speed={1500}
                      loop={true}
                      navigation={{
                        nextEl: ".success-video-next",
                        prevEl: ".success-video-prev",
                      }}
                      className="overflow-hidden"
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                          spaceBetween: 10,
                        },
                        576: {
                          slidesPerView: 2,
                          spaceBetween: 15,
                        },
                        768: {
                          spaceBetween: 24,
                        },
                      }}
                    >
                      {videoStories?.map((video, idx) => (
                        <SwiperSlide key={idx}>
                          <div className="student-image-wrap">
                            <div className="student-review-img">
                              <SwipperImage
                                src={
                                  // student?.thumbnail ??
                                  "/images/home/video-stories-big.png"
                                }
                                alt={video.name || "Student Image"}
                                className="student-img"
                              />
                              <div className="student-image-playbtn">
                                <button
                                  onClick={() => openModal(video)}
                                  className="play-btn"
                                  aria-label={`Play video of ${video.name}`}
                                >
                                  <FaCirclePlay className="play-icon" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                  <div className="student-arrow">
                    <div className="success-video-prev swiper-button-lock">
                      <button className="arrow-icon">
                        <FaChevronLeft />
                      </button>
                    </div>
                    <div className="success-video-next swiper-button-lock">
                      <button className="arrow-icon">
                        <FaChevronRight />
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Empty description="কোনো রিভিউ নেই" />
              )}
            </div>
          </div>

          <VideoStoryModal
            modalOpen={modalOpen}
            closeModal={closeModal}
            currentVideoLink={currentVideoLink}
          />
        </section>
 
    </>
  );
}
